import React from 'react';
import { store } from '@store/store';
import { getEnv } from '@config';
import { useScriptInHead } from '@hooks';
import Layout from './layout';

const FinancingBanner = (params) => {

  const { access_token: accessToken } = store.getState().login.jwt;
  const { urlScriptFinancingBanners, country } = getEnv();

  useScriptInHead(urlScriptFinancingBanners, () => {
    banners.renderBanner(
      accessToken,
      {
        isSeller: params.config.isSeller,
        callsToAction: params.config.callsToAction,
        country,
        title: params.config.title,
      },
    )
  });

  return (
    <div id="datamart-banner"></div>
  );
};

export default FinancingBanner;
